import { render } from "./KPIProgressBar.vue?vue&type=template&id=5162a8e5&scoped=true"
import script from "./KPIProgressBar.vue?vue&type=script&lang=js"
export * from "./KPIProgressBar.vue?vue&type=script&lang=js"

import "./KPIProgressBar.vue?vue&type=style&index=0&id=5162a8e5&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5162a8e5"]])

export default __exports__